<template>
  <div class="page">
    <navigator-menu :parentMsg="project_id"></navigator-menu>
    <el-card class="label-body">
      <div style="width:100%; font-weight: bold; font-size: 30px; text-align:center;">Concept Label</div>
      <el-divider />
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Current Label ({{ tagList.length }})</div></el-col>
        <el-col :span="18" style="font-weight: bold; font-size: 20px;">
          <el-tooltip
            v-for="(tag, index) in tagList"
            :key=index
            effect="dark"
            :content="getShortcuts(tag)"
            placement="top"
          >
            <el-tag
              :color=tag.background_color
              :style="{
                color: tag.text_color,
                borderColor: tag.background_color,
                }"
              size="large"
              closable
              @close="handleClose(tag)"
            >
              {{ tag.text }}
            </el-tag>
          </el-tooltip>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <el-row :gutter="10" style="height: 80px;">
		    <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Preview</div></el-col>
        <el-col :span="6" style="font-weight: bold; font-size: 20px;">
          <el-tooltip
          effect="dark"
          :content="getShortcuts(newTag)"
          placement="top"
          >
            <el-tag
              :color=newTag.background_color
              :style="{
                color: newTag.text_color,
                borderColor: newTag.background_color,
                }"
              size="large"
            >
              {{ newTag.text }}
            </el-tag>
          </el-tooltip>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <el-row :gutter="10" style="height: 80px;">
          <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Label's Name</div></el-col>
          <el-col :span="12"><el-input v-model="newTag.text" placeholder="Please enter label's name here"></el-input></el-col>
          <el-divider border-style="dashed" />
      </el-row>
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Shortcut Key</div></el-col>
        <el-col :span="3" style="margin-right:80px;">
          <el-select v-model="newTag.shortcut" placeholder="Please choose" size="large">
            <el-option
              v-for="key in keyOptions"
              :key="key"
              :label="key"
              :value="key"
            />
          </el-select>
        </el-col>
        <!-- <el-col :span="3"><el-checkbox v-model="newTag.useCtrl" label="C:Ctrl" size="large" /></el-col> -->
        <el-col :span="3"><el-checkbox v-model="newTag.useShift" label="S:Shift" size="large" /></el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Background Color</div></el-col>
        <el-col :span="6" style="font-weight: bold; font-size: 20px;">
          <el-input v-model="newTag.background_color" type="color"></el-input>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Text Color</div></el-col>
        <el-col :span="6" style="font-weight: bold; font-size: 20px;">
          <el-input v-model="newTag.text_color" type="color"></el-input>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
      <el-button type="success" @click="addTag" style="margin-left:30%;">Add Label</el-button>
      <el-button type="success" @click="resetNewTag" style="margin-left:10%;">Reset</el-button>
    </el-card>
    <!-- <el-backtop class="wow bounceInRight"/> -->
  </div>
</template>

<script>
import NavigatorMenu from "./ProNavigation";
import axios from 'axios'
import WOW from "wow.js";
export default {
  name: "Label",
  components: {
  //   AdvSearch,
  //   NavigatorMenuMobile,
    NavigatorMenu,
  //   Edit,
  //   Swiper
  },
  data(){
    return{
      project_id: this.$route.params.project_id,
      tagList: [],
	    newTag: {
        text: '',
        shortcut: '',
        useCtrl: false,
        useShift: false,
        background_color: '#409EAA',
        text_color: '#FFFFFF',
      },
      csrfToken:"",
      keyOptions:['a','b','c','d','e','f','g','h','i','g','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    // this.csrfToken = response.data.token;
    console.log('csrfToken:'+this.csrfToken)

    var url = window.location.href
    var begin = url.indexOf('/project/') + 9
    var end = url.indexOf('/premark')
    this.project_id = url.slice(begin, end)
    axios({
      method: 'get',
      url: '/api/api/projects/'+this.project_id+'/labels/',
      headers:{
        'X-CSRFToken': this.csrfToken,
      },
      params: {
        id: this.project_id,
      },
    }).then(response => {
      if(response.status == 200){
        this.tagList = response.data
      }
    }).catch((error) => {
      alert('网络连接失败！')
    })
  },
  mounted() {
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    wow.init();
    // this.echartinit();
  },
  methods: {
    handleClose(tag){
      axios({
        method: 'delete',
        url: '/api/api/projects/'+this.project_id+'/labels/'+tag.id,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if(response.status == 204){
          console.log('Delete标签成功')
          this.tagList.splice(this.tagList.indexOf(tag), 1)
        }
        else{
          alert('网络连接失败！')
        }
      }).catch((error) => {
        alert('网络连接失败！')
      })
    },
    getShortcuts(tag){
      if(tag.shortcut == null || tag.shortcut.length==0){
        return 'No shortcut key'
      }
      var temp = ''
      var ans = ''
      var shortcuts = tag.shortcut.split(" ")
      shortcuts.forEach(function(shortcut){
        if(shortcut == "shift"){
          temp = temp + "S-"
        }
        else if(shortcut == "ctrl"){
          temp = temp + "C-"
        }
        else{
          ans = temp + shortcut
        }
      })
      if(tag.useShift){
        ans = "S-"+ans
      }
      if(tag.useCtrl){
        ans = "C-"+ans
      }
      return '快捷键：'+ans
    },
    addTag(){
      var newTag = this.newTag
      if(newTag.text.length!=0 && newTag.shortcut.length!=0){
        try {
          this.tagList.forEach(function(item){
            if(item.text == newTag.text){
              alert("标签已存在！")
              throw new Error("Repeat!")
            }
          })
        } catch(e) {
          if(e.message=="Repeat!"){
            return
          }
        }
        var shortcut = newTag.shortcut
        if(newTag.useShift){
          shortcut = 'shift ' + shortcut
        }
        if(newTag.useCtrl){
          shortcut = 'ctrl ' + shortcut
        }
        axios({
          method: 'post',
          url: '/api/api/projects/'+this.project_id+'/labels/',
          headers:{
            'X-CSRFToken': this.csrfToken,
          },
          data: {
            text: newTag.text,
            shortcut: shortcut,
            background_color: newTag.background_color,
            text_color: newTag.text_color,
          },
        }).then(response => {
          console.log('response:')
          console.log(response)
          if(response.status == 201){
            this.tagList.push(response.data)
            this.resetNewTag()
          }
        }).catch((error) => {
          alert('网络连接失败！')
        })
      }
      else{
        alert("标签未Settings完整")
      }
    },
    resetNewTag(){
      var newtag = {
        id: 0,
        text: '',
        shortcut: '',
        useCtrl: false,
        useShift: false,
        background_color: '#409EAA',
        text_color: '#FFFFFF',
      }
      this.newTag = newtag
    },
  }
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.label-body{
  /* margin-left: 300px; */
  left: 350px;
  top: 15vh;
  position: absolute;
  height: 110%;
  width: 75%;
  background-color: rgba(255, 255, 255, 0.7);
  /* border-color: blueviolet;
  background-color: rgba(255, 255, 255, 0.7);; */
}
.el-tag{
    margin-right: 15px;
    font-size: 15px;
    border-color: borderColor;
}
</style>